import { defineMessages } from 'react-intl'

export const subscriptionTableMessages = defineMessages({
  title: {
    id: 'subscriptionTableMessages.title',
    description: 'Title for Subscription table',
    defaultMessage: 'Compare Plans',
  },
  dynamicUnlimitedLabel: {
    id: 'subscriptionTableMessages.dynamicUnlimitedElement',
    description: 'Dynamic unlimited label for the table cell',
    defaultMessage: 'Unlimited',
  },
  videoClipsLabel: {
    id: 'subscriptionTableMessages.videoClipsLabel',
    description: 'Subscription-features Video Recordings label',
    defaultMessage: '3 Months or about 1000 clips',
  },
  headerTitleFeatures: {
    id: 'subscriptionTableMessages.headerTitleFeatures',
    description: 'Header title Features',
    defaultMessage: 'Features',
  },
  headerTitleIncluded: {
    id: 'subscriptionTableMessages.headerTitleIncluded',
    description: 'Header title Included in all Savant Homes',
    defaultMessage: 'Included in all Savant Homes',
  },
  headerTitleEssentials: {
    id: 'subscriptionTableMessages.headerTitleEssentials',
    description: 'Subscription table Header title for Essentials ',
    defaultMessage: 'Savant Essentials',
  },
  headerTitleEssentialsYear: {
    id: 'subscriptionTableMessages.headerTitleEssentialsYear',
    description: 'Header title second part of Essentials plan title',
    defaultMessage: 'year',
  },

  backup: {
    id: 'subscriptionTableMessages.backup',
    description: 'Subscription-feature about backup and restore',
    defaultMessage: 'Home Backup & Restore',
  },
  appleTv: {
    id: 'subscriptionTableMessages.appleTv',
    description: 'Subscription-feature about Apple TV',
    defaultMessage: 'Savant Home App for Apple TV',
  },
  zoom: {
    id: 'subscriptionTableMessages.zoom',
    description: 'Subscription-feature about Zoom',
    defaultMessage: 'Conference Room Intergration with Zoom Rooms',
  },
  ring: {
    id: 'subscriptionTableMessages.ring',
    description: 'Subscription-feature about Ring',
    defaultMessage: 'Ring Doorbell and Camera Integration',
  },
  ringNote: {
    id: 'subscriptionTableMessages.ringNote',
    description: 'Subscription-feature notes about Ring',
    defaultMessage:
      'NOTE: Recording Storage is based on the subscibed Ring Protect Plan',
  },
  lutron: {
    id: 'subscriptionTableMessages.lutron',
    description: 'Subscription-feature about Lutron LEAP',
    defaultMessage: 'Lutron QSX and Ra3 Integration (LEAP)',
  },
  intercom: {
    id: 'subscriptionFeatures.intercom',
    description: 'Subscription-feature about Intercom',
    defaultMessage: 'Intercom',
  },
  video2n: {
    id: 'subscriptionTableMessages.video2n',
    description: 'Subscription-feature about 2N camera recordings',
    defaultMessage: '2N Entry Video Recordings',
  },
  enhancements: {
    id: 'subscriptionTableMessages.enhancements',
    description: 'Subscription-feature about future enhancements',
    defaultMessage: 'Future Features/Enhancements',
  },
  updates: {
    id: 'subscriptionTableMessages.updates',
    description: 'Subscription-feature about SavantOS upgrades and releases',
    defaultMessage: 'Bug Fixes in SavantOS Releases',
  },
  userExperience: {
    id: 'subscriptionTableMessages.userExperience',
    description: 'Subscription-feature about Premium user experience',
    defaultMessage: 'Savant App User Experience',
  },
  avDevices: {
    id: 'subscriptionTableMessages.avDevices',
    description: 'Subscription-feature about profile integration',
    defaultMessage: 'Direct Integration with 1000s of AV Devices and more',
  },
  savantMusic: {
    id: 'subscriptionTableMessages.savantMusic',
    description: 'Subscription-feature about Savant Music',
    defaultMessage: 'Savant Music (Streaming Music Services)',
  },
  lighting: {
    id: 'subscriptionTableMessages.lighting',
    description: 'Subscription-feature about Lighting control',
    defaultMessage: 'Savant Lighting Control',
  },
  notifications: {
    id: 'subscriptionTableMessages.notifications',
    description: 'Subscription-feature about notifications',
    defaultMessage: 'App Push and Email Notifications',
  },
  remote: {
    id: 'subscriptionTableMessages.remote',
    description: 'Subscription-feature about Remote Access',
    defaultMessage: 'Savant App Remote Access',
  },
  cloud: {
    id: 'subscriptionTableMessages.cloud',
    description: 'Subscription-feature about Alexa/Google Home/Siri TV IP etc.',
    defaultMessage: 'Cloud Voice Control with Alexa and Google',
  },
  proRemote: {
    id: 'subscriptionTableMessages.proRemote',
    description: 'Subscription-feature about Pro Remote',
    defaultMessage: 'Pro Remote Enabled Siri via Apple TV w/IP Control',
  },
  yaleAugust: {
    id: 'subscriptionTableMessages.yaleAugust',
    description: 'Subscription-feature about August integration',
    defaultMessage: 'August Locks Integration',
  },
  yale: {
    id: 'subscriptionTableMessages.yale',
    description: 'Subscription-feature about Yale integration',
    defaultMessage: 'Yale Locks Integration',
  },
  siri: {
    id: 'subscriptionFeatures.siri',
    description: 'Subscription-feature about Siri integration',
    defaultMessage: 'Siri & Apple Shortcuts with Natural Language Commands.',
  },
  siriNote: {
    id: 'subscriptionFeatures.siriNote',
    description: 'Subscription-feature notes about Siri',
    defaultMessage: 'NOTE: Requires a Mac Savant Host',
  },
  honeywell: {
    id: 'subscriptionFeatures.honeywell',
    description: 'Subscription-feature about Honeywell Thermostat integration',
    defaultMessage: 'Honeywell T Series Thermostat Integration',
  },
  schlage: {
    id: 'subscriptionFeatures.schlage',
    description: 'Subscription-feature about Schlage locks',
    defaultMessage: 'Schlage Locks Integration',
  },
  chamberlain: {
    id: 'subscriptionFeatures.chamberlain',
    description: 'Subscription-feature about Chamberlain Garage Door Openers',
    defaultMessage: 'Chamberlain Integration',
  },
})
